import { useEffect, useState } from 'react'
import { useApolloClient } from '@apollo/client'

import { MEDIA_SIGNED_URL_QUERY } from 'src/queries/Media'

export function useMediaSignedUrl(selfUrl: string | null | undefined): string | null {
    const client = useApolloClient()
    const [signedUrl, setSignedUrl] = useState<string | null>(null)

    useEffect(() => {
        if (!selfUrl) {
            setSignedUrl(null)
            return
        }

        let cancelled = false

        client
            .query<{ mediaSignedUrl: string | null }>({
                query: MEDIA_SIGNED_URL_QUERY,
                variables: { selfUrl },
                fetchPolicy: 'network-only',
            })
            .then(({ data }) => {
                if (!cancelled) {
                    setSignedUrl(data?.mediaSignedUrl ?? null)
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setSignedUrl(null)
                }
            })

        return () => {
            cancelled = true
        }
    }, [client, selfUrl])

    return signedUrl
}
